import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import ChatSeriesEditor from "./ChatSeriesEditor";
import { AudioChat, VideoChat, TextChat, ImageChat } from "src/types";

const ChatSeriesEditorPage = () => {
  const { lessonId, seriesId } = useParams();
  const location = useLocation();
  const [series, setSeries] = useState<
    TextChat | AudioChat | VideoChat | ImageChat | null
  >(null);

  useEffect(() => {
    if (seriesId) {
      fetch(`/api/series/${seriesId}`)
        .then((res) => res.json())
        .then((data) => setSeries(data));
    } else {
      const type = new URLSearchParams(location.search).get("type");

      const base = {
        id: Date.now(),
        lessonId,
        answer: [],
        options: [],
      };

      if (type === "TEXTCHAT") {
        const newSeries: TextChat = {
          ...base,
          title: "TEXTCHAT",
          question: { text: "" },
        };
        setSeries(newSeries);
      } else if (type === "AUDIOCHAT") {
        const newSeries: AudioChat = {
          ...base,
          title: "AUDIOCHAT",
          question: { audioUrl: "" },
        };
        setSeries(newSeries);
      } else if (type === "VIDEOCHAT") {
        const newSeries: VideoChat = {
          ...base,
          title: "VIDEOCHAT",
          question: { videoUrl: "" },
        };
        setSeries(newSeries);
      } else {
        const newSeries: ImageChat = {
          ...base,
          title: "IMAGECHAT",
          question: { imageUrl: "" },
        };
        setSeries(newSeries);
      }
    }
  }, [seriesId]);

  return (
    <div className="max-w-3xl mx-auto p-6">
      {series ? (
        <ChatSeriesEditor series={series} onUpdate={setSeries} />
      ) : (
        <p className="text-center text-gray-500">Loading series...</p>
      )}
    </div>
  );
};

export default ChatSeriesEditorPage;
